import Header from "../components/Header";
import "./scss/standardTerms.scss";
import { useEffect, useState, useRef } from "react";
import { rootReducer } from "../store/store";
import { useSelector, useDispatch } from "react-redux";
import { TermsType } from "../types/TermsType";
import KeyboardArrowUpOutlinedIcon from "@mui/icons-material/KeyboardArrowUpOutlined";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import SvgIcon from "@mui/material/SvgIcon";
import { Driver } from "../types/DriverTypes";
import SignatureModal from "../components/SignatureModal";
import { useHistory } from "react-router-dom";
import AlertModal from "../components/AlertModal";
import axios from "axios";
import { driver } from "../actions/authActions";
import {
  AlertType,
  alertType
} from "../types/CommonType";

type AuthState = ReturnType<typeof rootReducer>;
const StandardTerms: React.FC = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [rentCheckInfo, setRentCheckInfo] = useState<string>("");
    const resInfo = useSelector((state: AuthState) => state.store.resOneInfo);
    const data = resInfo && resInfo.data;
    const driverPrev = useSelector((state: AuthState) => state.store.driver);
    const driverList = driverPrev && driverPrev.data;

    const [alertTitle, setAlertTitle] = useState<string>("에약 조회 실패");
    const [alertContent, setAlertContent] = useState<string>("");
    const [alertShow, setAlertShow] = useState<boolean>(false);
    const [modalShow, setModalShow] = useState<boolean>(false);
    const [driverListProp, setDriverListProp] = useState<Driver[]>([]);
    const [driverNum, setDriverNum] = useState<number>(0);
    const [isScrolledToBottom, setIsScrolledToBottom] = useState<boolean>(false);
    console.log(driverList);
    const scrollContainerRef = useRef<HTMLDivElement>(null);
    const [alertInfo, setAlertInfo] = useState<AlertType>(alertType);

    const scrollToTop = () => {
        const container = scrollContainerRef.current;
        if (container) {
            animateScroll(0, container.scrollTop);
        }
    };

    const handleScroll = () => {
        const container = scrollContainerRef.current;
        if (container) {
            const maxScroll = container.scrollHeight - container.clientHeight;
            if (container.scrollTop >= maxScroll) {
                setIsScrolledToBottom(true);
            }
        }
    };

    const scrollToBottom = () => {
        const container = scrollContainerRef.current;
        if (container) {
            const maxScroll = container.scrollHeight - container.clientHeight;
            animateScroll(maxScroll, container.scrollTop);
        }
    };

    const animateScroll = (target: number, current: number) => {
        const step = (target - current) / 5; // 조절 가능한 부분: 더 큰 값을 사용하여 빠르게 이동
        let count = 0;

        const scrollAnimation = () => {
            count++;
            const nextScroll = current + step;
            const container = scrollContainerRef.current;

            if (container && count <= 10) {
                container.scrollTop = nextScroll;
                requestAnimationFrame(scrollAnimation);
            }
        };

        requestAnimationFrame(scrollAnimation);
    };

    const TermList = async () => {
        try{
            await axios
                .post(`${process.env.REACT_APP_MOBILE_API_URL}/V1/CompanyTermList.do`, {
                    companyId: data?.companyId,
                })
                .then((res) => {
                    console.log(res);
                    if (res.data && res.data.data.length > 0) {
                        res.data.data.map((e: TermsType) => {
                            if (e.termsType === "RENT_CHECK_INFO" && e.contents)
                                setRentCheckInfo(e.contents);
                        });
                    }
                });
        } catch(error){
            console.log(error);

            setAlertInfo({
                show: true,
                title: "키오스크 시스템 에러",
                content: "에러가 발생했습니다.<br/>다시 시도해주세요.",
                callback: () => window.location.reload()
            });
        }
    };

    const handleSaveSignature = async () => {

        // if (!isScrolledToBottom) {
        //     setAlertTitle("내용을 확인해주세요.");
        //     setAlertContent("표준 약관 내용을 끝까지 확인해주세요.");
        //     setAlertShow(true);
        //     return false;
        // }

        let result: boolean = false;
        driverList?.map((item: Driver, idx: number) => {
            console.log("singImg", item);
            if (item.driverName) {
                if (!item.singImg) {
                    setAlertTitle("서명해주세요.");
                    setAlertContent("임대차량 계약조건에 서명을 해주세요.");
                    setAlertShow(true);
                    result = false;
                } else result = true
            }

        });

        if (result) history.push("/addIns");
    };

    const handleTouchMove = (e: any) => {
        // 특정 div 영역 내에서는 터치 이벤트의 기본 동작을 막지 않음
        e.stopPropagation(); // 이벤트 전파 중단
    };


    useEffect(() => {
        console.log(driverList?.filter(e => e.driverName))
        dispatch(driver(driverList?.filter(e => e.driverName) || []));
        TermList();

        const rentInfoWrap = document.getElementById('rent-info-wrap');
        if (rentInfoWrap) {
            rentInfoWrap.addEventListener('touchmove', handleTouchMove, { passive: false });
            return () => {
                rentInfoWrap.removeEventListener('touchmove', handleTouchMove);
            };
        }
    }, []);

    return (
        <>
            <Header></Header>
            {alertShow && (
                <AlertModal
                    onClose={() => {
                        setAlertShow(false);
                    }}
                    title={alertTitle}
                    content={alertContent}
                ></AlertModal>
            )}
            {alertInfo.show && (
                <AlertModal
                onClose={() => {
                    if (alertInfo.callback) {
                    alertInfo.callback(); // 콜백 함수 호출
                    } else setAlertInfo((prev) => ({ ...prev, show: false }));
                }}
                title={alertInfo.title}
                content={alertInfo.content}
                ></AlertModal>
            )}
            <div className="contract-wrap">
                <div className="contract-title-wrap">전자계약서</div>

                <div className="contract-info-wrap">
                    <div className="term-title-wrap">자동차 대여 표준 약관</div>

                    <div
                        id="rent-info-wrap"
                        className="rent-info-wrap"
                        ref={scrollContainerRef}
                        dangerouslySetInnerHTML={{ __html: rentCheckInfo }}
                        onScroll={handleScroll}
                    ></div>
                    <div className="arrow-wrap">
                        <SvgIcon
                            component={KeyboardArrowUpOutlinedIcon}
                            style={{ fontSize: "8em", marginRight: "30px", color: "#e4e7ec" }}
                            onClick={scrollToTop}
                        ></SvgIcon>
                        <SvgIcon
                            component={KeyboardArrowDownOutlinedIcon}
                            style={{ fontSize: "8em", color: "#3E83F1" }}
                            onClick={scrollToBottom}
                        ></SvgIcon>
                    </div>
                    <div style={{ marginTop: '10px', marginBottom: '10px', fontWeight: '500', fontSize: '1.3em' }}>서명 영역을 한 번 터치 후 서명을 진행해주세요.</div>

                    {driverList &&
                        driverList.map((item: Driver, index: number) => (
                            <>
                                {
                                    item.driverName && (
                                        <div className="sign-wrap" key={index}>
                                            <div className="sign-info">
                                                <div style={{ width: "30%" }}>
                                                    {index === 0 ? "주 운전자" : "부 운전자"}
                                                </div>
                                                <div style={{ width: "30%" }}>{item.driverName}</div>
                                                <div
                                                    className="sign"
                                                    onClick={() => {
                                                        // if (!isScrolledToBottom) {
                                                        //     setAlertTitle("내용을 확인해주세요.");
                                                        //     setAlertContent("표준 약관 내용을 끝까지 확인해주세요.");
                                                        //     setAlertShow(true);
                                                        //     return false;
                                                        // }
                                                        setModalShow(true);
                                                        setDriverNum(index + 1);
                                                        setDriverListProp((prevState) => [...prevState, item]);
                                                    }}
                                                >
                                                    {item.singImg ? null : "(서명)"}
                                                    {item.singImg && (
                                                        <img
                                                            src={item.singImg}
                                                            style={{ width: "100%", maxHeight: "50px" }}
                                                            alt="Signature"
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </>
                        ))}
                </div>
                <div className="btn-wrap" style={{ width: "100%" }}>
                    <button onClick={handleSaveSignature}>다음</button>
                </div>
                <SignatureModal
                    driverNum={driverNum}
                    driverListProp={driverList}
                    isOpen={modalShow}
                    target={"SignatureReservation"}
                    onClose={() => {
                        setModalShow(false);
                    }}
                ></SignatureModal>
            </div>
        </>
    );
};

export default StandardTerms;
